// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__1TNaR","col":"styles_col__1oElY"};